import React from 'react';
// Constants
import { CompanyName, KeywordsPages, MainTitle } from '../../utils/Constants';
// Data
import {
  clipsAndFansitesStructuredData,
  clipsAndFansitesAdditionalMeta,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ClipsPageMainContainer from '../../components/clips/ClipsPageMainContainer';
import GeneralHeader from '../../components/general/GeneralHeader';
// Images
import clipsPageHeaderImage from '../../assets/images/headers/clips-and-fansites-barbie-style-header.png';
import clipsPageHeaderMobileImage from '../../assets/images/headers/clips-and-fansites-barbie-style-header-mobile.png';
import SammiMainImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-with-whip.png';

function ClipsPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Clips & Fansites'
        desc='Exclusive clips and premium content from Mistress Sammi Smith - Trans Dominatrix. Explore my fansites for more.'
        keywords={KeywordsPages}
        additionalMeta={clipsAndFansitesAdditionalMeta}
        structuredData={clipsAndFansitesStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={clipsPageHeaderImage}
            headerMobileImage={clipsPageHeaderMobileImage}
            mainTitle={`${MainTitle}`}
            subtitle={`My Fansites & Exclusive Content!`}
            mainImage={SammiMainImage}
          />
        </div>

        {/* Main page content */}
        <ClipsPageMainContainer />
      </div>
    </>
  );
}

export default ClipsPage;
